export const withPhi = {
	'data-phi': true,
} as const;

export const withHideActionFromViewOnly = {
	'data-actionable': true,
} as const;

export const withDisabledSnapshot = {
	chromatic: { disableSnapshot: true },
} as const;

export const withEnableInViewOnlyMode = {
	'data-ignore-view-only-mode': true,
} as const;

export const withLogRocketReveal = { 'data-public': true } as const;
